export const bluePurple = "#8884d8";
export const orange = "#FF8042";
export const green = "#82ca9d";
export const gold = "#ffd700";
export const barSize = 10;
export const chartMarginLeft = 10;
export const chartMarginRight = 10;
export const noDataChartMarginLeft = 70;
export const noDataChartMarginRight = 70;
export const tickFontSize = 12;
export const SALES = "売上高";
export const OPERATING_PROFIT = "営業利益";
export const OPERATING_PROFIT_RATIO = "営業利益率";
export const SALES_OPERATING_PROFIT_RATIO = "売上高営業利益率";
export const CAPITAL_SUM = "資本合計";
export const NET_ASSETS = "純資産";
export const LIABILITIES = "負債";
export const OWNED_CAPITAL_RATIO = "自己資本比率";
export const OPERATING_CASH_FLOW = "営業キャッシュフロー";
export const INVESTING_CASH_FLOW = "投資キャッシュフロー";
export const FINANCING_CASH_FLOW = "財務キャッシュフロー";
export const FREE_CASH_FLOW = "フリーキャッシュフロー";
export const STOCK = "株価";
export const ADJ_CLOSE = "調整後終値";
export const CANDLE_STICK = "ローソク足";
export const MA_25 = "移動平均(25)";
export const MA_75 = "移動平均(75)";
export const VOLUMES = "出来高";
export const STOCK_PRICE = "株価";
export const END = "終値";
